//Importing Sass Files
import './sass/main.scss';


 //import './js/customizer';
 import './js/navigation';
 import { ninjah } from './js/ninjah';
 import './js/skinny-ninjah';
 import './js/skip-link-focus-fix';
 import UIkit from 'uikit';
 import Icons from 'uikit/dist/js/uikit-icons';

console.log(ninjah('Sup'));
